function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import _ from 'lodash';
/*
 * This util is used for performing data transformation from a higher level component using Select
 * Given any array of objects, the method converts it to a Select-friendly array with display and value
 * If an array of numbers or strings are passed, it'll return the same value and display
 * @param {array} values, usually passed in as a prop, to be converted into select 'values' prop
 * @param {string} key to be used for display, defaults to 'display'
 * @param {string} key to be used for value, defaults to 'value'
 */

export var getSelectPropValues = function getSelectPropValues(values) {
  var displayKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'display';
  var valueKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'value';

  var hasNonObjectTypes = _.some(values, function (value) {
    return _typeof(value) !== 'object';
  });

  var selectValues;

  if (hasNonObjectTypes) {
    selectValues = values.map(function (value) {
      var display = String(value);
      return {
        display: display,
        value: display
      };
    });
  } else {
    selectValues = values.map(function (_ref) {
      var display = _ref[displayKey],
          value = _ref[valueKey];
      return {
        display: display,
        value: value
      };
    });
  }

  return selectValues;
};